import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { SecurityContextHolder } from 'core.ui-module_site-security';
import Logo from '../../images/logo/ms_researchinstitute_h_rev.png';

const Footer = ({ location }) => {
  const cssPathName = () => (location?.pathname ? location.pathname.replace(/\W/g, '-') : '');

  const externalClassName = !SecurityContextHolder.isAuthenticated() ? 'external' : '';
  return (
    <footer className={`footer ${externalClassName} page-${cssPathName()}`}>
      <div id="footer-additional" className="container my-0 footer-additional" />
      <div className="container content has-text-centered has-text-white pt-6 pb-6">
        <div className="columns">
          <div className="column">
            <div className="footer-content--left">
              <a href="/home">
                <img
                  decoding="async"
                  className="alignnone size-medium wp-image-13148"
                  src={Logo}
                  width="225px"
                />
              </a>
            </div>
          </div>
          <div className="column">
            <div className="footer-content--middle is-flex is-justify-content-center">
              <div className="address has-text-left">
                777 North Capitol Street, NE
                <br />
                Washington, DC 20002
                <br />
                {/* <a href="tel:+1202-962-8000">202 962-8000</a>
                <br /> */}
                <br />
                <a href="mailto:research@missionsq.org">research@missionsq.org</a>
                <br />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="footer-content--middle address">
              <a href="https://go.missionsq.org/MSRI-Newsletter-Sign-Up.html">
                <span className="has-text-white has-text-weight-bold">Sign up for eNewsletter</span>
              </a>
              <br />
              <a href="/privacy-policy">
                <span className="has-text-white has-text-weight-bold">Privacy Policy</span>
              </a>
              <br />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  footerItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
  footerLinks: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
    PropTypes.object,
  ]),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

Footer.defaultProps = {
  footerItems: undefined,
  footerLinks: undefined,
};

export default withRouter(Footer);
